<template>
    <div>
        <div>
            <div>
                <el-autocomplete v-model="commandSearch" :fetch-suggestions="querySearchAsync" placeholder="Rechercher une commande" @select="handleSelect" :clear="deleteSelectedCommand" :clearable="true">
                <el-button type="primary">OK</el-button>
            </div>
            <div>
                <el-autocomplete v-model="tiersSearch" :fetch-suggestions="querySearchAsync" placeholder="Rechercher une commande" @select="handleSelect" :clear="deleteSelectedCommand" :clearable="true">
                <el-button type="primary">OK</el-button>
            </div>
            <div>
                <h2>1. LE CLIENT</h2>
            </div>
            <div>
                <h2>2. LA COMMANDE</h2>
            </div>
        </div>
        <div>
            <h3>Liste des derniers PV</h3>
            <!-- <el-table
                :data="tablePV.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
                style="width: 100%">
                <el-table-column
                label="Date"
                prop="date">
                </el-table-column>
                <el-table-column
                label="Name"
                prop="name">
                </el-table-column>
                <el-table-column
                align="right">
                <template slot="header" slot-scope="scope">
                    <el-input
                    v-model="search"
                    size="mini"
                    placeholder="Type to search"/>
                </template>
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">Editer</el-button>
                    <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">Supprimer</el-button>
                </template>
                </el-table-column>
            </el-table> -->
        </div>
    </div>
</template>

<script>
import script from '../../../../script/script.js'
import scriptTiers from '../../../../script/script_tiers.js'
import scriptLivraison from '../../../../script/script_livraison.js'
var moment = require('moment');
function initialState (){
        return {
            commandSearch: "",
            tiersSearch: "",
            selectedCommand:null,
            selectedTiers:null,
            search:"",
        }
    }
export default {
    watch: {
    },
    props: {
    },
    created () {
    },
    data () {
        return initialState()
    },
    methods: {
        searchCommand: scriptLivraison.searchCommand,
        async querySearchAsync(queryString, cb) {
            this.products = await this.searchProducts(queryString)
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
            cb(this.products)
            }, 3000 * Math.random())
        },
        handleSelect(item) {
            this.selectedCommand = item
        },
        deleteSelectedCommand(){
            this.selectedCommand = null
        },
    },
    computed:{
        tablePv(){
            
        }
    }

}
</script>

<style>

</style>